import React, { useState, useRef, useEffect } from "react";
import CopyText from "../shared/CopyText";
import whiteSparkle from "~/images/sparkle-white.svg";
import Button from "../shared/Button";
const ResultDescription = ({ description, charCount, totalCount, siteAudit = false, handleGenerate }) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [description]);

  return (
    <div className={`bg-white/70 shadow-md shadow-[#6248fe1f] relative ${siteAudit ? "px-2 py-4 rounded-md" : "rounded-[20px] p-[26px] min-h-[200px]"}`}>
      <textarea
        ref={textareaRef}
        readOnly
        value={description}
        id="inputText"
        className="w-full pr-16 bg-transparent border-none outline-none resize-none  text-base leading-relaxed text-black placeholder-black focus:ring-0"
      ></textarea>
      <div className="flex justify-between items-center">
        <div>
          {charCount && (
            <Button className="bg-white hover:bg-white px-4 py-2 !text-[#888888] text-[12px] border border-gray-200 rounded-2xl flex items-center space-x-2 transition-colors cursor-text">
              <span className="">
                Characters: {charCount}/{totalCount}
              </span>
            </Button>
          )}
        </div>
        <div className="flex items-center gap-2">
          <CopyText description={description} siteAudit={siteAudit} />
          {siteAudit && (
            <Button
              onClick={handleGenerate}
              className="!bg-[#6248fe] !hover:bg-[#593ff5] px-4 py-2 border text-white text-[16px] !rounded-[7px] flex items-center space-x-2 transition-colors"
            >
              <img src={whiteSparkle} />
              <span class="font-medium">Generate New</span>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
export default ResultDescription;
